// Post-sign-in redirect targets: only same-origin paths that start with a single slash are kept (no protocol-relative, backslash or control-character tricks), normalised to path, query and hash and checked again after normalisation, because dot segments such as /.//host turn into a protocol-relative URL.
function isSinglySlashed(value: string): boolean {
  return value.startsWith("/") && !value.startsWith("//") && !value.startsWith("/\\");
}

function hasControlCharacter(value: string): boolean {
  for (let index = 0; index < value.length; index += 1) {
    const code = value.charCodeAt(index);
    if (code < 0x20 || code === 0x7f) {
      return true;
    }
  }
  return false;
}

export function safeRedirect(value: unknown, origin: string = window.location.origin): string | null {
  if (typeof value !== "string" || !isSinglySlashed(value) || hasControlCharacter(value)) {
    return null;
  }
  try {
    const url = new URL(value, origin);
    const target = `${url.pathname}${url.search}${url.hash}`;
    return url.origin === new URL(origin).origin && isSinglySlashed(target) ? target : null;
  } catch {
    return null;
  }
}
